import React from 'react';

/**
 * The label above each block on the dashboard — "حسابي", "آخر الإشعارات",
 * "تابع التعلم". 18px bold in gray/900, with 16px of padding around it, which
 * is what sets every block on the page to the same left edge.
 *
 * `count` is the orange pill beside "آخر الإشعارات". It is drawn only when
 * there is something unread: a "0" in a badge reads as a number the reader has
 * to act on, and there is nothing there.
 *
 * The pill sits *after* the text in the DOM, which puts it on the text's left
 * in Arabic and its right in English — either way, on the side the reading
 * finishes on, which is where the design has it.
 */
const SectionHeading = ({ children, count = 0, className = '' }) => (
    <div className={`tw-flex tw-items-center tw-gap-[10px] tw-p-[16px] ${className}`}>
        <h2 className="tw-text-[18px] tw-font-bold tw-leading-[1.5] tw-text-v2-neutral-900 tw-m-0">
            {children}
        </h2>

        {count > 0 && (
            <span
                className={
                    'tw-inline-flex tw-min-w-[28px] tw-items-center tw-justify-center ' +
                    'tw-rounded-[6px] tw-bg-v2-student-count tw-px-[7px] tw-py-[1px] ' +
                    'tw-text-[12px] tw-font-bold tw-leading-[1.5] tw-text-white'
                }
            >
                {count}
            </span>
        )}
    </div>
);

export default SectionHeading;
